module.exports = __webpack_public_path__ + "static/img/downUrl.f93d4303.png";